export const CREATE = "CREATE";
export const EDIT = "EDIT";
export const CHANGE_ADMIN = "CHANGE_ADMIN";
